// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data/BabelStoneFlags.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
    font-family: flags;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
.flags {
    font-family: flags;
}

body {
    background-color: #bfbfbf;
    margin: 0;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0;
    overflow: hidden;
}

.login-wrapper input#usernameInput, .login-wrapper input#passwordInput {
    width: 250px;
    height: 40px;
    display: inline-block;
    margin: 5px 0px 5px 10px;
}

.login-wrapper label {
    display: inline-block;
    font-weight: bold;
    font-size: 24px;
    text-align: right;
    font-family: monospace;
}

.login-wrapper button {
    /*margin: 50px;*/

    /*width: 150px;*/

    /*width: fit-content;
    height: 50px;
    font-size: 24px;
    border-radius: 25px;*/

    /*border-color: rgba(0, 255, 225, 1);*/

    /*border-color: rgba(0, 255, 155, 1);*/

    /*border-style: solid;*/

    /*cursor: pointer;*/

    margin: 50px 5px;
    /*width: fit-content;*/
    width: 200px;
    height: 55px;
    /*height: 65px;*/
    padding: 10px 5px 10px;
    border: 2px solid black;
    /*border-radius: 0;*/
    border-radius: 10px;
    background-color: #ffffff;
    color: #000000;
    text-transform: uppercase;
    text-decoration: none;
    transition: .5s;
    cursor: pointer;
    text-align: center;
    font-size: 24px;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    justify-content: center;
    align-content: center;
}

#mainTitleLogin {
    font-size: 64px;
    margin: 20px;
}

#loginText {
    font-size: 48px;
    margin-bottom: 50px;
}

.form-login {
    width: -moz-fit-content;
    width: fit-content;
    border: solid black 2px;
    padding: 20px;
}

.css-input {
    padding: 5px;
    font-size: 16px;
    border-width: 1px;
    border-color: #cccccc;
    background-color: #ababab;
    color: #000000;
    border-style: solid;
    border-radius: 11px;
    box-shadow: 0px 0px 0px rgba(206,75,75,.0);
    text-shadow: 0px 0px 0px rgba(66,66,66,.0);
}
.css-input:focus {
    outline:none;
}

/* Error Message */
.offscreen {
    position: absolute;
    left: -9999px;
}

.errmsg {
    background-color: lightpink;
    color: firebrick;
    font-weight: bold;
    padding: 0.5rem;
    margin-bottom: 0.5rem;
    width: 250px;
}
/* Fin Error Message */

/*

    - Generator -

    Generator part of CSS

*/

.main {
    position: relative;
    width: 90vw;
    height: 90vh;
    outline: 0px dashed orange;
    display: flex;
    flex-direction: row;
    box-sizing: border-box;

}

.main div.block{
    /*display: inline-block;*/
    width: 30%;
    padding: 10px;;
    margin: 0vh auto;
    box-sizing: border-box;
    outline: 0px dashed red;
    border: 1px solid black;
    background-color: #eee;
    overflow-y: auto;
}
.main div#left-block{
    vertical-align: top;
    /*margin-top: 0vh;*/
}

textarea {
    resize: none;
}

.main div.left-block {
    margin-right: 60px;
}

.main div.left-block div.left-inside {
    margin-top: 40%;
}

.middle-line {
    display: inline-block;
    background-color: black;
    width: 2px;
    height: 90%;
    position: absolute;
    top:0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
}

.main div.right-block {
    margin-left: 60px;
}

.main div.right-inside {
    box-sizing: content-box;
    width: 100%;
}

.main div.right-inside > *:not(img) {
    width: 100%;
    box-sizing: border-box;
    margin: 10px auto 0;
}


.main div.right-inside > #nameQRCode {
    display : inline-block;
    border: 1px solid black;
    height: 70px;
}

fieldset > div > input[type=radio] {
    width: 15px;
    height: 15px;
    /*transform: scale(1.5);*/
}

fieldset#typeObjectSelector > div {
    -webkit-user-select: none; /* Safari */ /* Firefox */ /* IE10+/Edge */
    user-select: none; /* Standard */
    width: 40%;
    margin: 5px auto 5px;
    text-align: left;
    padding-left: 20px;
}

#desc-group {
    outline: 0px dashed purple;
    width: 100%;
    height: 40px;
}
#desc-group > * {

}
.textarea-desc {
    border: 1px solid black;
    border-radius: 0;
    background-color: #fff;
    font-family: Courier, "Courier New", monospace;
    color: black;
    font-size: 0.9em;
    margin: 0px 10px 0px 0px;
    float: left;
    width: 75%;
}
.textarea-desc::placeholder{
    color: black;
}
#descCharLengthP {
    float: right;
    padding: 10px;
    margin-right: 10px;
    outline: 0px dashed purple;
}

#qrcodePreview {
    background-color: #8c8c8c;
    border: 3px solid black;
    margin: auto;
}
#qrcode-display {
    display: flex;
    margin: 0 auto 0;
}

#typeObjectSelector > div > *:not(legend){
    /* essayer de regrouper les choix d'une manière différente */
}

#typeObjectSelector > div {
    border: 1px solid black;
    width: -moz-fit-content;
    width: fit-content;
    padding: 2px 7px 2px;
    margin-bottom: 5px;
    /*background-color: #8c8c8c;*/
    background-color: #d0d0d0;
}

/*#generator-counter {
    text-transform: uppercase;
}*/

/*

    - Admin -

    Admin part of CSS

*/

.admin-container {
    display: flex;
    width: 100%;
    height: 100%;
    margin: 0;
    /*margin-left: 12px;
    margin-right: 12px;*/
    padding: 20px 0 20px;
    flex-direction: row;
    justify-content: space-evenly;
}

.admin-panel {
    width: 31%;
    background-color: #eee;
    padding: 0;
    margin: 0;
    /*height: 880px;*/
}
.admin-panel-content {
    padding: 0;
    margin: 0 0 20px 0;
}

.title-center {
    /*margin-left: auto;
    margin-right: auto;
    width: 100%;*/
    text-align: center;
}

.center {
    margin-left: auto;
    margin-right: auto;
    /*width: 50%;*/
}
.text-center {
    list-style: none;
    text-align: center;
}

.span-center{
    width: 100%;
    display: block;
    text-align: center;
    margin: 0 auto 20px;
}

ul {
    padding: 0;
    margin: 0;
    width: 65%;
}

ul > li {
    cursor: pointer;
    /*border: 2px solid;*/
    /*border: 2px solid black;*/
}

ul > li:not(:last-child) {
    margin-bottom: 10px;
}

ul > li:hover {
    color: #23d5ab;
    border: 2px solid #23d5ab;
}

#account-creator {
    width: 80%;
}

#admin-form-buttons {
    width: 100%;
    margin: 20px auto 20px;
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    flex-direction: row;
    justify-content: space-evenly;
}
form > section:not(#admin-form-buttons, #admin-form-radio-buttons) {
    display: grid;
}
form > section:not(#admin-form-buttons, #admin-form-radio-buttons, :first-child) > label {
    /*margin-left: 4%;*/
    /*margin: 10px auto 0px;*/
    margin: 15px 4% 0px;
}

form > section:first-child > label {
    /*margin-left: 4%;*/
    /*margin: 10px auto 0px;*/
    margin: 10px 4% 0px;
}
form > section:not(#admin-form-buttons, #admin-form-radio-buttons) > input {
    width: 90%;
    margin: 10px auto 0px;
    border: none;
    border-bottom: 1px solid black;
    background-color: rgba(0,0,0,0);
}
form > section > input::placeholder {
    /*color: black;*/
}
form > section > span#admin-form-password-show-icon {
    width: -moz-fit-content;
    width: fit-content;
    color: red;
    display: inline;
    vertical-align: middle;
    margin-left: 90%;
    margin-top: -6%;
    cursor: pointer;
    -webkit-user-select: none;
            user-select: none;
}
form > section#admin-form-radio-buttons {
    margin-top: 10px;
    /*margin-top: 20px;*/
}
form > section#admin-form-radio-buttons > label {
    margin: 10px 4% 0px;
}
form > section#admin-form-radio-buttons > fieldset {
    margin: 0px 4% 0px;
    text-align: left;
}
form > section#admin-form-radio-buttons > fieldset > input {
    text-align: left;
    margin-left: 80px;
}
form > section#admin-form-radio-buttons > fieldset > legend {
    text-align: center;
}

.button-admin-form {
    /*width: 150px;*/
    width: 40%;
    height: auto;
    border: 2px solid black;
    padding: 10px 5px 10px;
    margin: auto 5px auto;
    border-radius: 0;
    background-color: #ffffff;
    text-transform: uppercase;
    cursor: pointer;
}

span#admin-panel-form-status {
    display:block;
    width: 90%;
    height: 100%;
    margin: 0 auto 0;
    text-align: center;

}

/*

    Home

    Home part of CSS

 */

.home-container{
    border: 2px solid black;
    border-radius: 40px;
    width: 13vw;
    height: 45vh;
    padding: 50px;
    margin: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
}

.user-info {
    position: absolute;
    top: 10px;
    right: 10px;
    background-color: #fff;
    padding: 5px 10px;
    border: 1px solid #ccc;
    border-radius: 5px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
}

.user-info span {
    font-weight: bold;
}

/*

    Buttons

    Buttons part of CSS

 */

.home-links {
    width: 150px;
    height: auto;
    border: 2px solid black;
    padding: 10px 5px 10px;
    margin: 5px 5px;
    border-radius: 0;
    background-color: #ffffff;
    text-transform: uppercase;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-decoration: none;
    color: #000000;
    transition: .5s;
    cursor: pointer;
    text-align: center;
}
²²
.home-links:hover {
    transition: .5s;
    border-color: #ffffff;
    background-color: #000000;
    color: #ffffff;
}

.button-go-back {
    position: fixed;
    top: 3%;
    left: 2%;
}

.gray-button {
    background-color: #808080;
}

.button-disabled {
    color: #666;
    background-color: #ccc;
    border: 1px solid #aaa;
    cursor: not-allowed;
}

.orange-button {
    background-color: orange;
}

.button-container {
    display: flex;
    justify-content: center;
    align-items: center;
}

#nbQRCodeSelector {
    display: flex;
    align-items: center;
    justify-content: center;
}

.radio-item {
    margin-right: 50px;
}


`, "",{"version":3,"sources":["webpack://./src/style.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,4CAAoC;AACxC;AACA;IACI,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,SAAS;IACT,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,qBAAqB;IACrB,wBAAwB;AAC5B;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,eAAe;IACf,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;;IAEhB,gBAAgB;;IAEhB;;;yBAGqB;;IAErB,sCAAsC;;IAEtC,sCAAsC;;IAEtC,uBAAuB;;IAEvB,mBAAmB;;IAEnB,gBAAgB;IAChB,sBAAsB;IACtB,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,sBAAsB;IACtB,uBAAuB;IACvB,oBAAoB;IACpB,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;IACd,yBAAyB;IACzB,qBAAqB;IACrB,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,uBAAuB;IACvB,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,uBAAkB;IAAlB,kBAAkB;IAClB,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,qBAAqB;IACrB,yBAAyB;IACzB,cAAc;IACd,mBAAmB;IACnB,mBAAmB;IACnB,0CAA0C;IAC1C,0CAA0C;AAC9C;AACA;IACI,YAAY;AAChB;;AAEA,kBAAkB;AAClB;IACI,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,2BAA2B;IAC3B,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,qBAAqB;IACrB,YAAY;AAChB;AACA,sBAAsB;;AAEtB;;;;;;CAMC;;AAED;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,0BAA0B;IAC1B,aAAa;IACb,mBAAmB;IACnB,sBAAsB;;AAE1B;;AAEA;IACI,yBAAyB;IACzB,UAAU;IACV,aAAa;IACb,gBAAgB;IAChB,sBAAsB;IACtB,uBAAuB;IACvB,uBAAuB;IACvB,sBAAsB;IACtB,gBAAgB;AACpB;AACA;IACI,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,uBAAuB;IACvB,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,KAAK;IACL,SAAS;IACT,OAAO;IACP,QAAQ;IACR,YAAY;AAChB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,uBAAuB;IACvB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,sBAAsB;IACtB,mBAAmB;AACvB;;;AAGA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB,EAAE,WAAW,EACd,YAAY,EACb,eAAe;IACtC,iBAAiB,EAAE,aAAa;IAChC,UAAU;IACV,oBAAoB;IACpB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;IAC1B,WAAW;IACX,YAAY;AAChB;AACA;;AAEA;AACA;IACI,uBAAuB;IACvB,gBAAgB;IAChB,sBAAsB;IACtB,8CAA8C;IAC9C,YAAY;IACZ,gBAAgB;IAChB,wBAAwB;IACxB,WAAW;IACX,UAAU;AACd;AACA;IACI,YAAY;AAChB;AACA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;IACzB,uBAAuB;IACvB,YAAY;AAChB;AACA;IACI,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,4DAA4D;AAChE;;AAEA;IACI,uBAAuB;IACvB,uBAAkB;IAAlB,kBAAkB;IAClB,oBAAoB;IACpB,kBAAkB;IAClB,6BAA6B;IAC7B,yBAAyB;AAC7B;;AAEA;;EAEE;;AAEF;;;;;;CAMC;;AAED;IACI,aAAa;IACb,WAAW;IACX,YAAY;IACZ,SAAS;IACT;wBACoB;IACpB,oBAAoB;IACpB,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA;IACI,UAAU;IACV,sBAAsB;IACtB,UAAU;IACV,SAAS;IACT,iBAAiB;AACrB;AACA;IACI,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI;;iBAEa;IACb,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;AAClB;AACA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,SAAS;IACT,UAAU;AACd;;AAEA;IACI,eAAe;IACf,qBAAqB;IACrB,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;IACX,sBAAsB;IACtB,aAAa;IACb,eAAe;IACf,SAAS;IACT,mBAAmB;IACnB,6BAA6B;AACjC;AACA;IACI,aAAa;AACjB;AACA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;AACvB;AACA;IACI,UAAU;IACV,qBAAqB;IACrB,YAAY;IACZ,8BAA8B;IAC9B,+BAA+B;AACnC;AACA;IACI,gBAAgB;AACpB;AACA;IACI,uBAAkB;IAAlB,kBAAkB;IAClB,UAAU;IACV,eAAe;IACf,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,yBAAiB;YAAjB,iBAAiB;AACrB;AACA;IACI,gBAAgB;IAChB,oBAAoB;AACxB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,YAAY;IACZ,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;IACrB,gBAAgB;IAChB,yBAAyB;IACzB,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;;AAEtB;;AAEA;;;;;;EAME;;AAEF;IACI,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,sBAAsB;IACtB,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,wCAAwC;AAC5C;;AAEA;IACI,iBAAiB;AACrB;;AAEA;;;;;;EAME;;AAEF;IACI,YAAY;IACZ,YAAY;IACZ,uBAAuB;IACvB,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,yBAAyB;IACzB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,qBAAqB;IACrB,cAAc;IACd,eAAe;IACf,eAAe;IACf,kBAAkB;AACtB;AACA;;IAEI,eAAe;IACf,qBAAqB;IACrB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,OAAO;IACP,QAAQ;AACZ;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,sBAAsB;IACtB,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;AACtB","sourcesContent":["@font-face {\n    font-family: flags;\n    src: url(\"data/BabelStoneFlags.ttf\");\n}\n.flags {\n    font-family: flags;\n}\n\nbody {\n    background-color: #bfbfbf;\n    margin: 0;\n    height: 100vh;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 0;\n    overflow: hidden;\n}\n\n.login-wrapper input#usernameInput, .login-wrapper input#passwordInput {\n    width: 250px;\n    height: 40px;\n    display: inline-block;\n    margin: 5px 0px 5px 10px;\n}\n\n.login-wrapper label {\n    display: inline-block;\n    font-weight: bold;\n    font-size: 24px;\n    text-align: right;\n    font-family: monospace;\n}\n\n.login-wrapper button {\n    /*margin: 50px;*/\n\n    /*width: 150px;*/\n\n    /*width: fit-content;\n    height: 50px;\n    font-size: 24px;\n    border-radius: 25px;*/\n\n    /*border-color: rgba(0, 255, 225, 1);*/\n\n    /*border-color: rgba(0, 255, 155, 1);*/\n\n    /*border-style: solid;*/\n\n    /*cursor: pointer;*/\n\n    margin: 50px 5px;\n    /*width: fit-content;*/\n    width: 200px;\n    height: 55px;\n    /*height: 65px;*/\n    padding: 10px 5px 10px;\n    border: 2px solid black;\n    /*border-radius: 0;*/\n    border-radius: 10px;\n    background-color: #ffffff;\n    color: #000000;\n    text-transform: uppercase;\n    text-decoration: none;\n    transition: .5s;\n    cursor: pointer;\n    text-align: center;\n    font-size: 24px;\n    display: flex;\n    flex-direction: column;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-content: center;\n}\n\n#mainTitleLogin {\n    font-size: 64px;\n    margin: 20px;\n}\n\n#loginText {\n    font-size: 48px;\n    margin-bottom: 50px;\n}\n\n.form-login {\n    width: fit-content;\n    border: solid black 2px;\n    padding: 20px;\n}\n\n.css-input {\n    padding: 5px;\n    font-size: 16px;\n    border-width: 1px;\n    border-color: #cccccc;\n    background-color: #ababab;\n    color: #000000;\n    border-style: solid;\n    border-radius: 11px;\n    box-shadow: 0px 0px 0px rgba(206,75,75,.0);\n    text-shadow: 0px 0px 0px rgba(66,66,66,.0);\n}\n.css-input:focus {\n    outline:none;\n}\n\n/* Error Message */\n.offscreen {\n    position: absolute;\n    left: -9999px;\n}\n\n.errmsg {\n    background-color: lightpink;\n    color: firebrick;\n    font-weight: bold;\n    padding: 0.5rem;\n    margin-bottom: 0.5rem;\n    width: 250px;\n}\n/* Fin Error Message */\n\n/*\n\n    - Generator -\n\n    Generator part of CSS\n\n*/\n\n.main {\n    position: relative;\n    width: 90vw;\n    height: 90vh;\n    outline: 0px dashed orange;\n    display: flex;\n    flex-direction: row;\n    box-sizing: border-box;\n\n}\n\n.main div.block{\n    /*display: inline-block;*/\n    width: 30%;\n    padding: 10px;;\n    margin: 0vh auto;\n    box-sizing: border-box;\n    outline: 0px dashed red;\n    border: 1px solid black;\n    background-color: #eee;\n    overflow-y: auto;\n}\n.main div#left-block{\n    vertical-align: top;\n    /*margin-top: 0vh;*/\n}\n\ntextarea {\n    resize: none;\n}\n\n.main div.left-block {\n    margin-right: 60px;\n}\n\n.main div.left-block div.left-inside {\n    margin-top: 40%;\n}\n\n.middle-line {\n    display: inline-block;\n    background-color: black;\n    width: 2px;\n    height: 90%;\n    position: absolute;\n    top:0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    margin: auto;\n}\n\n.main div.right-block {\n    margin-left: 60px;\n}\n\n.main div.right-inside {\n    box-sizing: content-box;\n    width: 100%;\n}\n\n.main div.right-inside > *:not(img) {\n    width: 100%;\n    box-sizing: border-box;\n    margin: 10px auto 0;\n}\n\n\n.main div.right-inside > #nameQRCode {\n    display : inline-block;\n    border: 1px solid black;\n    height: 70px;\n}\n\nfieldset > div > input[type=radio] {\n    width: 15px;\n    height: 15px;\n    /*transform: scale(1.5);*/\n}\n\nfieldset#typeObjectSelector > div {\n    -webkit-user-select: none; /* Safari */\n    -moz-user-select: none; /* Firefox */\n    -ms-user-select: none; /* IE10+/Edge */\n    user-select: none; /* Standard */\n    width: 40%;\n    margin: 5px auto 5px;\n    text-align: left;\n    padding-left: 20px;\n}\n\n#desc-group {\n    outline: 0px dashed purple;\n    width: 100%;\n    height: 40px;\n}\n#desc-group > * {\n\n}\n.textarea-desc {\n    border: 1px solid black;\n    border-radius: 0;\n    background-color: #fff;\n    font-family: Courier, \"Courier New\", monospace;\n    color: black;\n    font-size: 0.9em;\n    margin: 0px 10px 0px 0px;\n    float: left;\n    width: 75%;\n}\n.textarea-desc::placeholder{\n    color: black;\n}\n#descCharLengthP {\n    float: right;\n    padding: 10px;\n    margin-right: 10px;\n    outline: 0px dashed purple;\n}\n\n#qrcodePreview {\n    background-color: #8c8c8c;\n    border: 3px solid black;\n    margin: auto;\n}\n#qrcode-display {\n    display: flex;\n    margin: 0 auto 0;\n}\n\n#typeObjectSelector > div > *:not(legend){\n    /* essayer de regrouper les choix d'une manière différente */\n}\n\n#typeObjectSelector > div {\n    border: 1px solid black;\n    width: fit-content;\n    padding: 2px 7px 2px;\n    margin-bottom: 5px;\n    /*background-color: #8c8c8c;*/\n    background-color: #d0d0d0;\n}\n\n/*#generator-counter {\n    text-transform: uppercase;\n}*/\n\n/*\n\n    - Admin -\n\n    Admin part of CSS\n\n*/\n\n.admin-container {\n    display: flex;\n    width: 100%;\n    height: 100%;\n    margin: 0;\n    /*margin-left: 12px;\n    margin-right: 12px;*/\n    padding: 20px 0 20px;\n    flex-direction: row;\n    justify-content: space-evenly;\n}\n\n.admin-panel {\n    width: 31%;\n    background-color: #eee;\n    padding: 0;\n    margin: 0;\n    /*height: 880px;*/\n}\n.admin-panel-content {\n    padding: 0;\n    margin: 0 0 20px 0;\n}\n\n.title-center {\n    /*margin-left: auto;\n    margin-right: auto;\n    width: 100%;*/\n    text-align: center;\n}\n\n.center {\n    margin-left: auto;\n    margin-right: auto;\n    /*width: 50%;*/\n}\n.text-center {\n    list-style: none;\n    text-align: center;\n}\n\n.span-center{\n    width: 100%;\n    display: block;\n    text-align: center;\n    margin: 0 auto 20px;\n}\n\nul {\n    padding: 0;\n    margin: 0;\n    width: 65%;\n}\n\nul > li {\n    cursor: pointer;\n    /*border: 2px solid;*/\n    /*border: 2px solid black;*/\n}\n\nul > li:not(:last-child) {\n    margin-bottom: 10px;\n}\n\nul > li:hover {\n    color: #23d5ab;\n    border: 2px solid #23d5ab;\n}\n\n#account-creator {\n    width: 80%;\n}\n\n#admin-form-buttons {\n    width: 100%;\n    margin: 20px auto 20px;\n    display: flex;\n    flex-wrap: wrap;\n    gap: 10px;\n    flex-direction: row;\n    justify-content: space-evenly;\n}\nform > section:not(#admin-form-buttons, #admin-form-radio-buttons) {\n    display: grid;\n}\nform > section:not(#admin-form-buttons, #admin-form-radio-buttons, :first-child) > label {\n    /*margin-left: 4%;*/\n    /*margin: 10px auto 0px;*/\n    margin: 15px 4% 0px;\n}\n\nform > section:first-child > label {\n    /*margin-left: 4%;*/\n    /*margin: 10px auto 0px;*/\n    margin: 10px 4% 0px;\n}\nform > section:not(#admin-form-buttons, #admin-form-radio-buttons) > input {\n    width: 90%;\n    margin: 10px auto 0px;\n    border: none;\n    border-bottom: 1px solid black;\n    background-color: rgba(0,0,0,0);\n}\nform > section > input::placeholder {\n    /*color: black;*/\n}\nform > section > span#admin-form-password-show-icon {\n    width: fit-content;\n    color: red;\n    display: inline;\n    vertical-align: middle;\n    margin-left: 90%;\n    margin-top: -6%;\n    cursor: pointer;\n    user-select: none;\n}\nform > section#admin-form-radio-buttons {\n    margin-top: 10px;\n    /*margin-top: 20px;*/\n}\nform > section#admin-form-radio-buttons > label {\n    margin: 10px 4% 0px;\n}\nform > section#admin-form-radio-buttons > fieldset {\n    margin: 0px 4% 0px;\n    text-align: left;\n}\nform > section#admin-form-radio-buttons > fieldset > input {\n    text-align: left;\n    margin-left: 80px;\n}\nform > section#admin-form-radio-buttons > fieldset > legend {\n    text-align: center;\n}\n\n.button-admin-form {\n    /*width: 150px;*/\n    width: 40%;\n    height: auto;\n    border: 2px solid black;\n    padding: 10px 5px 10px;\n    margin: auto 5px auto;\n    border-radius: 0;\n    background-color: #ffffff;\n    text-transform: uppercase;\n    cursor: pointer;\n}\n\nspan#admin-panel-form-status {\n    display:block;\n    width: 90%;\n    height: 100%;\n    margin: 0 auto 0;\n    text-align: center;\n\n}\n\n/*\n\n    Home\n\n    Home part of CSS\n\n */\n\n.home-container{\n    border: 2px solid black;\n    border-radius: 40px;\n    width: 13vw;\n    height: 45vh;\n    padding: 50px;\n    margin: auto;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n}\n\n.user-info {\n    position: absolute;\n    top: 10px;\n    right: 10px;\n    background-color: #fff;\n    padding: 5px 10px;\n    border: 1px solid #ccc;\n    border-radius: 5px;\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);\n}\n\n.user-info span {\n    font-weight: bold;\n}\n\n/*\n\n    Buttons\n\n    Buttons part of CSS\n\n */\n\n.home-links {\n    width: 150px;\n    height: auto;\n    border: 2px solid black;\n    padding: 10px 5px 10px;\n    margin: 5px 5px;\n    border-radius: 0;\n    background-color: #ffffff;\n    text-transform: uppercase;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    text-decoration: none;\n    color: #000000;\n    transition: .5s;\n    cursor: pointer;\n    text-align: center;\n}\n²²\n.home-links:hover {\n    transition: .5s;\n    border-color: #ffffff;\n    background-color: #000000;\n    color: #ffffff;\n}\n\n.button-go-back {\n    position: fixed;\n    top: 3%;\n    left: 2%;\n}\n\n.gray-button {\n    background-color: #808080;\n}\n\n.button-disabled {\n    color: #666;\n    background-color: #ccc;\n    border: 1px solid #aaa;\n    cursor: not-allowed;\n}\n\n.orange-button {\n    background-color: orange;\n}\n\n.button-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n#nbQRCodeSelector {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.radio-item {\n    margin-right: 50px;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
